import React, {ReactNode} from 'react';
import {Control, useController} from 'react-hook-form';
import cn from 'classnames';

import {getInputState, InputStateType} from 'shared/ui/Input/inputHelper';
import {isTranslate} from 'shared/lib/lang';
import Correct from 'shared/ui/icons/General/Correct';
import Wrong from 'shared/ui/icons/General/Wrong';
import {PALETTE} from 'shared/config/model/palette';
import {brandColor} from 'shared/lib/colors';

interface IUseInputStateParams {
    control: Control<any>,
    name: string,
    defaultValue?: unknown,
    validate: boolean,
}

export const useInputState = ({control, name, defaultValue, validate}: IUseInputStateParams) => {
    const {field, fieldState} = useController({name, control, defaultValue});
    const state = getInputState({fieldState, value: field.value, validate});

    return {field, state};
};

export const getInputClassName = (
    styles: Record<string, string>,
    state: InputStateType,
    withAutofill = false,
): string => {
    const prefix = isTranslate() ? 'enInput' : 'input';

    return cn(styles[prefix], styles[`${prefix}_${state}`], withAutofill && styles[`${prefix}_autofill`]);
};

interface IInputStateIconProps {
    state: InputStateType,
    defaultIcon: ReactNode,
    filledIcon?: ReactNode,
}

export const InputStateIcon: React.FC<IInputStateIconProps> = ({state, defaultIcon, filledIcon}) => {
    const correct = <Correct color={brandColor(PALETTE.accent, PALETTE.success)}/>;

    switch (state) {
        case 'error':
            return <Wrong/>;
        case 'valid':
            return correct;
        case 'filled':
            return <>{filledIcon ?? correct}</>;
        default:
            return <>{defaultIcon}</>;
    }
};
